import CalculationStateData from "./data";

export default function calculationStateDataFromJson(json) {
    return new CalculationStateData(
        json.voyageId,
        json.computation,
        json.stateId,
        json.stateValue,
        json.stateTitle,
        json.progress
    )
}